import styled, { css, RuleSet } from 'styled-components'

import { Button } from '@/components/business/market-shop/button'
import { OrderStatusBarStatus } from '@/components/business/market-shop/order-status-bar/order-status-bar.types'
import { Icon } from '@/components/ui/icon'

export const Container = styled.div<{ $status: OrderStatusBarStatus }>(({ theme, $status }) => {
  const baseStyles = css`
    display: flex;
    align-items: center;
    padding: ${theme.space['12']};
    gap: ${theme.space['8']};
    border-radius: ${theme.border.radius['8']};
    min-width: fit-content;
    width: 100%;
  `

  const activeStyles: Record<OrderStatusBarStatus, RuleSet> = {
    awaiting_pickup: css`
      background-color: ${theme.colors['green100']};
    `,
    in_progress: css`
      background-color: ${theme.colors['blue100']};
    `,
    new: css`
      background-color: ${theme.colors['orange100']};
    `,
  }

  return css`
    ${baseStyles}
    ${activeStyles[$status]}}
  `
})

export const StatusIcon = styled(Icon)<{ $status: OrderStatusBarStatus }>(({ theme, $status }) => {
  const activeStyles: Record<OrderStatusBarStatus, RuleSet> = {
    awaiting_pickup: css`
      color: ${theme.colors['green500']};
    `,
    in_progress: css`
      color: ${theme.colors['blue500']};
    `,
    new: css`
      color: ${theme.colors['orange500']};
    `,
  }

  return css`
    ${activeStyles[$status]}}
  `
})

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['4']};
  `,
)

export const TrackButton = styled(Button)<{ $status: OrderStatusBarStatus }>(
  ({ theme, $status }) => {
    const baseStyles = css`
    margin-left: auto;
    padding: ${theme.space['10']} ${theme.space['12']};
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2rem;
    border-radius: ${theme.border.radius['4']};
  `

    const activeStyles: Record<OrderStatusBarStatus, RuleSet> = {
      awaiting_pickup: css`
      background-color: ${theme.colors['green200']};
      color: ${theme.colors['green500']};
    `,
      in_progress: css`
      background-color: ${theme.colors['blue200']};
      color: ${theme.colors['blue500']};
    `,
      new: css`
      background-color: ${theme.colors['orange200']};
      color: ${theme.colors['orange500']};
    `,
    }

    return css`
    ${baseStyles}
    ${activeStyles[$status]}}
  `
  },
)
